import { EComponentTypes } from "../../../Utils/Enums";
import { ClientModel, OrderModel, ProductModel } from "../../../Utils/Models";
import { formatDate, getFullName } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

export const clientPaymentsColumns = [
  {
    name: "orderId",
    label: Vocabulary.id,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    name: "orderDetails",
    label: Vocabulary.id,
    options: {
      sortField: "orderDetails.orderNumber",
      customBodyRender: (value: OrderModel) => {
        return value?.orderNumber;
      },
      exportValue: (value: OrderModel) => value?.orderNumber || "",
    },
  },
  {
    name: "amount",
    label: Vocabulary.amount,
    options: {
      customBodyRender: (value: number) => {
        return <span style={{ color: "#2e7d32", fontWeight: "bold" }}>{value}</span>;
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "orderDetails",
    label: Vocabulary.product,
    options: {
      sortField: "orderDetails.product.name",
      customBodyRender: (value: OrderModel) => {
        return value?.product?.name;
      },
      exportValue: (value: OrderModel) => value?.product?.name || "",
    },
  },
  {
    name: "clientDetails",
    label: Vocabulary.cursant,
    options: {
      sortField: "clientDetails.firstName",
      customBodyRender: (value: ClientModel) => {
        return getFullName(value);
      },
      exportValue: (value: ClientModel) => getFullName(value),
    },
  },
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: any) => {
        return formatDate(value, "dd.MM.yyyy HH:mm");
      },
      exportValue: (value: any) => value ? formatDate(value, "dd.MM.yyyy HH:mm") : "",
    },
  },
];

/**
 * Generates an array of filter objects for the client payments report.
 *
 * @param {any[]} instructors - The list of instructors to use for the autocomplete filter.
 * @param {ProductModel[]} products - The list of products to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const clientPaymentsFilters = (
  instructors: any,
  products: ProductModel[]
) => [
  {
    property: "instructorId",
    autocompleteFilterProperty: "instructorId",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
  },
  {
    property: "productId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.product,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: products,
  },
];
